/** Pause after spoken acknowledgement before deferred voice navigation. */
export const POST_ACKNOWLEDGEMENT_NAV_DELAY_MS = 500;

/** Brief conversational pause after the opening greeting before listening begins. */
export const POST_GREETING_LISTEN_DELAY_MS = 800;

/**
 * Runs a deferred voice action after acknowledgement speech completes.
 * When TTS was unavailable, the action runs immediately (no artificial delay).
 */
export function runAfterVoiceAcknowledgement(callback, { defer = false } = {}) {
  if (!callback) {
    return null;
  }

  if (!defer) {
    callback();
    return null;
  }

  return window.setTimeout(callback, POST_ACKNOWLEDGEMENT_NAV_DELAY_MS);
}

/**
 * Runs listening handoff after greeting speech completes (TTS onEnd only).
 */
export function runAfterGreetingSpeech(callback) {
  if (!callback) {
    return null;
  }

  return window.setTimeout(callback, POST_GREETING_LISTEN_DELAY_MS);
}
